<template>
  <v-sheet class="bg-transparent pa-12 my-auto" height="1200" rounded>
    <v-card flat class="bg-deep-orange-lighten-3 mx-auto px-6 py-8" max-width="400">
      <!-- Logo Section -->
      <div class="text-center mb-6">
        <v-avatar size="100" class="mb-4">
          <v-img src="@/assets/ayhan512.png" contain></v-img>
        </v-avatar>
        <h2 class="uyghur text-white text-h5 mb-2">ئايخان مەدەنىيەت ۋە مائارىپ فوندى</h2>
        <p class="uyghur text-white text-subtitle-2">كىرىش سۇپىسى</p>
      </div>

      <!-- Error/Warning Alert -->
      <v-alert
        v-if="errorMessage"
        type="error"
        variant="tonal"
        class="uyghur mb-4"
        closable
        @click:close="errorMessage = ''"
      >
        {{ errorMessage }}
      </v-alert>

      <v-alert
        v-if="warningMessage"
        type="warning"
        variant="tonal"
        class="uyghur mb-4"
        closable
        @click:close="warningMessage = ''"
      >
        {{ warningMessage }}
      </v-alert>

      <v-form v-model="form" class="uyghur text-white" @submit.prevent="onSubmit">
        <v-text-field 
          hide-details="true" 
          clearable 
          color="deep-orange-lighten-5" 
          variant="underlined" 
          v-model="username" 
          :readonly="loading" 
          :rules="[required]" 
          class="mb-2"
          prepend-inner-icon="mdi-account-outline" 
          label="ئىشلەتكۈچى ئىسمى"
          placeholder="ئىشلەتكۈچى ئىسمىڭىزنى كىرگۈزۈڭ"
          :error-messages="usernameErrors"
        ></v-text-field>

        <v-text-field 
          hide-details="true" 
          clearable 
          color="deep-orange-lighten-5" 
          variant="underlined" 
          v-model="password" 
          :readonly="loading"
          :append-inner-icon="hide_password ? 'mdi-eye-off' : 'mdi-eye'" 
          :type="hide_password ? 'password' : 'text'"
          prepend-inner-icon="mdi-lock-outline" 
          :rules="[required, passwordRule]" 
          label="پارول" 
          placeholder="پارولىڭىزنى كىرگۈزۈڭ"
          :error-messages="passwordErrors"
          @click:append-inner="hide_password = !hide_password">
        </v-text-field>

        <br>

        <v-btn 
          :disabled="!form" 
          :loading="loading" 
          block 
          color="deep-orange-lighten-1" 
          size="large" 
          type="submit"
          variant="elevated"
          class="uyghur"
        >
          كىرىش
        </v-btn>
      </v-form>
    </v-card>
  </v-sheet>
</template>
<script>
export default {
  data: () => ({
    hide_password: true,
    form: false,
    username: null,
    password: null,
    loading: false,
    errorMessage: '',
    warningMessage: '',
    usernameErrors: [],
    passwordErrors: [],
  }),

  methods: {
    async onSubmit() {
      if (!this.form) return

      // Clear previous errors
      this.clearErrors()

      this.loading = true
      
      try {
        // Create AbortController for timeout
        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 10000) // 10 second timeout
        
        const requestOptions = {
          method: 'POST',
          headers: { 
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ username: this.username, password: this.password }),
          signal: controller.signal,
          mode: 'cors',
          credentials: 'omit'
        }
        
        const response = await fetch('https://anatil.xsada.net/api/login', requestOptions)
        clearTimeout(timeoutId)
        
        if (response.status === 200) {
          const resp = await response.json()
          this.$store.commit('login', resp.token)
          this.$router.push({name: 'attendance'})
        } else if (response.status === 404) {
          // Django backend returns 404 for invalid credentials
          this.errorMessage = 'ئىشلەتكۈچى ئىسمى ياكى پارول خاتا! قايتا سىناپ كۆرۈڭ.'
        } else if (response.status === 401) {
          this.errorMessage = 'ئىشلەتكۈچى ئىسمى ياكى پارول خاتا! قايتا سىناپ كۆرۈڭ.'
        } else if (response.status === 403) {
          this.warningMessage = 'ھېسابىڭىزدا خاتالىق بار، باشقۇرغۇچى بىلەن ئالاقىلىشىڭ'
        } else if (response.status === 429) {
          this.warningMessage = 'بەك كۆپ سىناپ كەتتىڭىز. بىر نەچچە مىنۇت كۈتۈپ قايتا سىناپ كۆرۈڭ.'
        } else if (response.status >= 500) {
          this.errorMessage = 'مۇلازىمېتىر خاتالىقى. كېيىنرەك قايتا سىناپ كۆرۈڭ.'
        } else {
          this.errorMessage = 'كىرىش خاتالىقى. قايتا سىناپ كۆرۈڭ.'
        }
      } catch (error) {
        console.error('Login error:', error)
        
        // Handle different types of network errors
        if (error.name === 'TypeError') {
          if (error.message.includes('Failed to fetch') || error.message.includes('ERR_NAME_NOT_RESOLVED')) {
            this.errorMessage = 'تور باغلىنىشى خاتالىقى. ئىنتېرنېت باغلىنىشىڭىزنى تەكشۈرۈڭ ياكى VPN ئىشلىتىپ سىناپ كۆرۈڭ.'
          } else if (error.message.includes('ERR_NETWORK')) {
            this.errorMessage = 'تور باغلىنىشى مەۋجۇت ئەمەس. ئىنتېرنېت باغلىنىشىڭىزنى تەكشۈرۈڭ.'
          } else if (error.message.includes('ERR_CONNECTION_REFUSED')) {
            this.errorMessage = 'مۇلازىمېتىر بىلەن باغلىنىش مۇمكىن ئەمەس. كېيىنرەك قايتا سىناپ كۆرۈڭ.'
          } else if (error.message.includes('ERR_TIMED_OUT')) {
            this.errorMessage = 'باغلىنىش ۋاقتى ئۆتتى. قايتا سىناپ كۆرۈڭ.'
          } else {
            this.errorMessage = 'تور باغلىنىشى خاتالىقى. ئىنتېرنېت باغلىنىشىڭىزنى تەكشۈرۈڭ.'
          }
        } else if (error.name === 'AbortError') {
          this.errorMessage = 'ئىشەنچە ئۈزۈلدى. قايتا سىناپ كۆرۈڭ.'
        } else {
          this.errorMessage = 'كۈتۈلمىگەن خاتالىق يۈز بەردى. قايتا سىناپ كۆرۈڭ.'
        }
      } finally {
        this.loading = false
      }
    },

    clearErrors() {
      this.errorMessage = ''
      this.warningMessage = ''
      this.usernameErrors = []
      this.passwordErrors = []
    },

    required(v) {
      return !!v || 'بۇ سۆز كۈچىدىن بوش بولسا بولمايدۇ'
    },

    passwordRule(v) {
      if (!v) return true
      if (v.length < 6) {
        return 'پارول كەم دېگەندە 6 خىل بەلگە بولۇشى كېرەك'
      }
      return true
    },
  },
}
</script>